import { AmazonMusic, ApplePodcast, GooglePodcast } from "@areahub/icons";
import { Link } from "@areahub/ui";
import { Box, Heading, SimpleGrid, Tooltip } from "@chakra-ui/react";
import { PageBlockBreakpoint } from "lib/gcms";
import { nanoid } from "nanoid";
import { SiSpotify } from "react-icons/si";

export const podcastDistributors: PodcastDistributor[] = [
  {
    href: "https://podcasts.apple.com/us/podcast/climate-clear/id1591105259",
    desc: "Apple Podcasts",
    icon: ApplePodcast,
    colorScheme: "applePodcasts",
  },
  {
    href: "https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy50cmFuc2lzdG9yLmZtL2NsaW1hdGUtY2xlYXI",
    desc: "Google Podcasts",
    icon: GooglePodcast,
    colorScheme: "google",
  },
  {
    href: "https://open.spotify.com/show/09uIBGYH7dPEwWXWxasOYi",
    desc: "Spotify Podcasts",
    icon: SiSpotify,
    colorScheme: "spotify",
    color: "spotify.500",
  },
  {
    href: "https://music.amazon.com/podcasts/65335518-5e3a-4da2-811a-764ae18b0fca/climate-clear",
    desc: "Amazon Music",
    icon: AmazonMusic,
    colorScheme: "amazonMusic",
  },
];

export const PodcastPlatforms = ({ title, bg }: PageBlockBreakpoint) => (
  <Box as="section" py="12" bg={bg}>
    <Box maxW={{ base: "xl", md: "5xl" }} mx="auto" px={{ base: "6", md: "8" }}>
      <Heading
        size="2xl"
        mb="4"
        mx="auto"
        textAlign="center"
        fontWeight="extrabold"
      >
        {title}
      </Heading>

      <SimpleGrid
        columns={{ base: 2, lg: 4 }}
        spacing={{ base: "12", md: "12", lg: "16" }}
        mt="12"
        alignItems="center"
        justifyItems="center"
        fontSize="2xl"
      >
        {podcastDistributors.map(
          ({ href, desc, icon, colorScheme, ...rest }) => (
            <Tooltip
              label={"Listen on " + desc}
              fontSize="xs"
              aria-label={desc}
              key={nanoid()}
              bg="transparent"
              shadow="none"
              color="text"
            >
              <Link
                href={href}
                isExternal
                aria-describedby={"Listen on " + desc}
                // transition="all .2s ease-in-out"
                _focus={{ outline: "none" }}
                _hover={{
                  textDecoration: "none",
                  transform: "scale(1.1)",
                }}
              >
                <Box
                  as={icon}
                  _focus={{ outline: "none" }}
                  color={rest?.color}
                  h="24"
                  w="24"
                />
              </Link>
            </Tooltip>
          ),
        )}
      </SimpleGrid>
    </Box>
  </Box>
);

export interface PodcastDistributor {
  /** @description link to podcast platform */
  href: string;
  /** @description The description of the platform i.e Apple Podcasts. This will be inserted into the label and aria-label props of the Tooltip component associated with the platform. It's important to note that the description will also be appended with the string "Listen on ". i.e for desc = 'Spotify' the resulting tooltip will be "Listen on Spotify" */
  desc: string;
  /** @description Icon component associated with the platform */
  icon: any;
  /** @description For colorScheme props on buttons tags and other chakra components */
  colorScheme?: string;
  /** @description In case if the icon component comes from a library like react-icons, use this to ensure the color matches the brand of the platform */
  color?: string;
}
